import { useEffect, useState } from "react";

import {
  fetchBloc0Stats,
  fetchBloc1Stats,
  fetchBloc2Stats,
  fetchBloc3Stats,
  fetchBloc4Stats,
  fetchBloc5Stats,
  fetchBloc6Stats,
  fetchBloc7Stats,
  fetchTimeseries,
} from "../../services/dashboardService";
import { getDashboardFiltersKey } from "../../utils/dashboard/queryParams";

export default function useDashboardBlocksData(filters) {
  const [bloc0Stats, setBloc0Stats] = useState(null);
  const [bloc0Loading, setBloc0Loading] = useState(false);
  const [bloc0Err, setBloc0Err] = useState(null);
  const [bloc0SoilSeries, setBloc0SoilSeries] = useState([]);

  const [bloc1Stats, setBloc1Stats] = useState(null);
  const [bloc1Loading, setBloc1Loading] = useState(false);
  const [bloc1Err, setBloc1Err] = useState(null);
  const [bloc1PhSeries, setBloc1PhSeries] = useState([]);

  const [bloc2Stats, setBloc2Stats] = useState(null);
  const [bloc2Loading, setBloc2Loading] = useState(false);
  const [bloc2Err, setBloc2Err] = useState(null);

  const [bloc3Stats, setBloc3Stats] = useState(null);
  const [bloc3Loading, setBloc3Loading] = useState(false);
  const [bloc3Err, setBloc3Err] = useState(null);

  const [bloc4Stats, setBloc4Stats] = useState(null);
  const [bloc4Loading, setBloc4Loading] = useState(false);
  const [bloc4Err, setBloc4Err] = useState(null);

  const [bloc5Stats, setBloc5Stats] = useState(null);
  const [bloc5Loading, setBloc5Loading] = useState(false);
  const [bloc5Err, setBloc5Err] = useState(null);

  const [bloc6Stats, setBloc6Stats] = useState(null);
  const [bloc6Loading, setBloc6Loading] = useState(false);
  const [bloc6Err, setBloc6Err] = useState(null);

  const [bloc7Stats, setBloc7Stats] = useState(null);
  const [bloc7Loading, setBloc7Loading] = useState(false);
  const [bloc7Err, setBloc7Err] = useState(null);

  const filtersKey = getDashboardFiltersKey(filters);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc0Loading(true);
        setBloc0Err(null);

        const [data, soilSeries] = await Promise.all([
          fetchBloc0Stats(filters),
          fetchTimeseries("tempSoil_mean", filters),
        ]);
        if (cancelled) return;

        setBloc0Stats(data);
        setBloc0SoilSeries(soilSeries?.points || []);
      } catch (e) {
        if (!cancelled) {
          setBloc0Err(e?.message || "Error carregant estadístiques de bloc0");
          setBloc0Stats(null);
          setBloc0SoilSeries([]);
        }
      } finally {
        if (!cancelled) setBloc0Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc2Loading(true);
        setBloc2Err(null);

        const data = await fetchBloc2Stats(filters);
        if (cancelled) return;

        setBloc2Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc2Err(e?.message || "Error carregant estadístiques de bloc2");
          setBloc2Stats(null);
        }
      } finally {
        if (!cancelled) setBloc2Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc3Loading(true);
        setBloc3Err(null);

        const data = await fetchBloc3Stats(filters);
        if (cancelled) return;

        setBloc3Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc3Err(e?.message || "Error carregant estadístiques de bloc3");
          setBloc3Stats(null);
        }
      } finally {
        if (!cancelled) setBloc3Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc4Loading(true);
        setBloc4Err(null);

        const data = await fetchBloc4Stats(filters);
        if (cancelled) return;

        setBloc4Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc4Err(e?.message || "Error carregant estadístiques de bloc4");
          setBloc4Stats(null);
        }
      } finally {
        if (!cancelled) setBloc4Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc5Loading(true);
        setBloc5Err(null);

        const data = await fetchBloc5Stats(filters);
        if (cancelled) return;

        setBloc5Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc5Err(e?.message || "Error carregant estadístiques de bloc5");
          setBloc5Stats(null);
        }
      } finally {
        if (!cancelled) setBloc5Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc6Loading(true);
        setBloc6Err(null);

        const data = await fetchBloc6Stats(filters);
        if (cancelled) return;

        setBloc6Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc6Err(e?.message || "Error carregant estadístiques de bloc6");
          setBloc6Stats(null);
        }
      } finally {
        if (!cancelled) setBloc6Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc7Loading(true);
        setBloc7Err(null);

        const data = await fetchBloc7Stats(filters);
        if (cancelled) return;

        setBloc7Stats(data);
      } catch (e) {
        if (!cancelled) {
          setBloc7Err(e?.message || "Error carregant estadístiques de bloc7");
          setBloc7Stats(null);
        }
      } finally {
        if (!cancelled) setBloc7Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setBloc1Loading(true);
        setBloc1Err(null);

        const [data, phSeries] = await Promise.all([
          fetchBloc1Stats(filters),
          fetchTimeseries("ph_mean", filters),
        ]);
        if (cancelled) return;

        setBloc1Stats(data);
        setBloc1PhSeries(phSeries?.points || []);
      } catch (e) {
        if (!cancelled) {
          setBloc1Err(e?.message || "Error carregant estadístiques de bloc1");
          setBloc1Stats(null);
          setBloc1PhSeries([]);
        }
      } finally {
        if (!cancelled) setBloc1Loading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filtersKey, filters]);

  return {
    bloc0Stats,
    bloc0Loading,
    bloc0Err,
    bloc0SoilSeries,
    bloc1Stats,
    bloc1Loading,
    bloc1Err,
    bloc1PhSeries,
    bloc2Stats,
    bloc2Loading,
    bloc2Err,
    bloc3Stats,
    bloc3Loading,
    bloc3Err,
    bloc4Stats,
    bloc4Loading,
    bloc4Err,
    bloc5Stats,
    bloc5Loading,
    bloc5Err,
    bloc6Stats,
    bloc6Loading,
    bloc6Err,
    bloc7Stats,
    bloc7Loading,
    bloc7Err,
  };
}
